import { SidePanel } from '@wix/design-system';
import classNames from 'classnames';
import React__default from 'react';
import { UiComponentsProvider } from '../../ui-components-provider.js';
import { ROOT } from './data-hooks.js';
import { s as styleInject } from '../../style-inject.es-746bb8ed.js';
import { FooterActions } from '../common/footer-actions.js';
import 'ricos-context';
import '../common/data-hooks.js';

var css_248z = ".w8Me6{--wds-side-panel-footer-padding-vertical:18px}";
var classes = {"footer":"w8Me6"};
styleInject(css_248z);

const SidePanelDesktopLayout = ({
  title,
  onCancel,
  onSave,
  content,
  dataHook,
  noPadding
}) => {
  return /* @__PURE__ */ React__default.createElement(UiComponentsProvider, null, /* @__PURE__ */ React__default.createElement(
    SidePanel,
    {
      onCloseButtonClick: onCancel,
      height: "100vh",
      dataHook: classNames(ROOT, dataHook)
    },
    /* @__PURE__ */ React__default.createElement(SidePanel.Header, { title, showDivider: true }),
    /* @__PURE__ */ React__default.createElement(SidePanel.Content, { stretchVertically: true, noPadding }, content),
    /* @__PURE__ */ React__default.createElement(SidePanel.Footer, { showDivider: true, className: classes.footer }, /* @__PURE__ */ React__default.createElement(FooterActions, { onCancel, onSave }))
  ));
};

export { SidePanelDesktopLayout };
//# sourceMappingURL=side-panel-desktop-layout.js.map
